/* eslint-disable no-unused-vars */
import React from "react";
import "./ManageStock.css";
import StockHistoryTable from "./StockHistoryTable";
import { ToastContainer } from "react-toastify";
import StockHistoryController from "./StockHistoryController";
import useFormattedDate from "../../../../../context/useFormattingUtils";
const ManageStockView = () => {
  const {
    stockData,
    handleDeleteStock,
    currentPage,
    totalCount,
    handlePageChange,
    loading,
    handleDataUpdate,
    rowsPerPage,
    handleRowsPerPageChange,
    searchTerm,
    handleSearch
  } = StockHistoryController();
  const { formatDate } = useFormattedDate();
  const columns = [
    { header: "Product Title", field: "combinedField" },
    { header: "Added Stock", field: "arrayField" },
    { header: "Total Pieces Arrived", field: "total_stock_arrived" },
    { header: "Current Stock", field: "current_stock" },
    { header: "Purchase Price", field: "purchaseprice" },
    { header: "Selling Price", field: "sellingprice" },
    { header: "Vendor", field: "vendor_name" },
    { header: "Entry Date", field: "date" },
    { header: "Expiry Date", field: "expiry_date" },
    { header: "Status", field: "segment_status" },
  ];

  // const formattedStockData = stockData.map((item) => ({
  //   ...item,
  //   date: formatDate(item.date),
  // }));
  const formattedData = stockData.map((item) => ({
    ...item,
    date: item.date ? formatDate(item.date) : "N/A"
  }));

  return (
    <>
      <ToastContainer />
      <div className="responsive-box">
        <div className="inventory-header">
          <div className="inventory-title">Stock History</div>
        </div>
        <StockHistoryTable
          data={formattedData}
          columns={columns}
          showFooter={true}
          showAction={true}
          onDelete={handleDeleteStock}
          onDataUpdate={handleDataUpdate}
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={(page) => handlePageChange(page)}
          loading={loading}
          searchTerm={searchTerm}
          onSearch={handleSearch}
        />
      </div>
    </>
  );
};

export default ManageStockView;
